module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kelli Stanley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("KELLI STANLEY's first novel in the 1940 San Francisco-set Miranda Corbie series, CITY OF DRAGONS, was met with overwhelming critical acclaim and was a finalist for the prestigious Los Angeles Times Book Prize. Stanley also writes a highly-praised series set in Roman Britain, the latest of which is THE CURSE-MAKER. Her debut novel, NOX DORMIENDA, won the Bruce Alexander Award for best historical mystery of 2008. She makes her home in Dashiell Hammett's San Francisco, earned a Master's Degree in Classics, and loves jazz, old movies, fedoras, Art Deco and speakeasies.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5TOKch/images/9780312603601.jpg?1727382233653",
      "alt": "This image is the cover for the book City of Dragons, The Miranda Corbie Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("City of Dragons, The Miranda Corbie Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("February, 1940. In San Francisco's Chinatown, fireworks explode as the city celebrates Chinese New Year with a Rice Bowl Party, a three day-and-night carnival designed to raise money and support for China war relief. Miranda Corbie is a 33-year-old private investigator who stumbles upon the fatally shot body of Eddie Takahashi. The Chamber of Commerce wants it covered up. The cops acquiesce. All Miranda wants is justice--whatever it costs. From Chinatown tenements, to a tattered tailor's shop in Little Osaka, to a high-class bordello draped in Southern Gothic, she shakes down the city--her city--seeking the truth. An outstanding series debut.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Minotaur Books A Thomas Dunne Book\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0